import { makeAutoObservable } from 'mobx';
import { Customization, CustomizationValue } from './types';
import { buildValidationSchema } from './validation';


class CustomizationsState {
    list: Customization[] = [];
    values: Record<string, CustomizationValue> = {};
    errors: Record<string, string> = {};
    validationSchema: Record<
        string,
        Array<(value: CustomizationValue) => boolean | string>
    > = {};

    constructor(customizations: Customization[] = []) {
        makeAutoObservable(this, {
            validationSchema: false,
            isEmpty: false,
            isValid: false,
        });
        this.validationSchema = buildValidationSchema(customizations);
        this.list = customizations;
    }

    updateValue = (customizationId: string, value: CustomizationValue) => {
        this.values[customizationId] = value;
        if (this.errors[customizationId]) {
            delete this.errors[customizationId];
        }
    };

    validate = (customizationId: string) => {
        const currentValue = this.values[customizationId];

        for (const rule of this.validationSchema[customizationId]) {
            const error = rule(currentValue);

            if (typeof error === 'string') {
                this.errors[customizationId] = error;
                return;
            }
        }
    };

    validateAll = () => {
        this.list.forEach((customization) => {
            this.validate(customization.id);
        });
    };

    isEmpty = () => {
        return this.list.length === 0;
    };

    isValid = () => {
        return Object.keys(this.errors).length === 0;
    };
}

export default CustomizationsState;
